import NotificationsWrapper from './NotificationsWrapper';

export default NotificationsWrapper;
